import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VToolbar,{attrs:{"flat":"","color":_vm.color,"height":"40","dark":""}},[_c(VToolbarTitle,[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }